var map = {
	"./1.png": 34,
	"./2.png": 35,
	"./22.png": 36,
	"./23.png": 37,
	"./3.png": 38,
	"./4.png": 39,
	"./55769960_116907276143171_3978053186920382464_n.jpg": 40,
	"./57465186_127719958395236_2192767300677926912_o.jpg": 41,
	"./React-App11.png": 42,
	"./a1.png": 43,
	"./a2.png": 44,
	"./ai.jpg": 45,
	"./c1.png": 46,
	"./c2.png": 47,
	"./devops.jpg": 48,
	"./gd.jpg": 49,
	"./logo1.png": 50,
	"./mag.png": 51,
	"./no-image.png": 52,
	"./pointing.jpg": 53,
	"./s1.png": 11,
	"./s2.png": 12,
	"./s3.png": 13,
	"./taxi.png": 54,
	"./todo.png": 55,
	"./ui.png": 56,
	"./ui1.png": 57,
	"./zd.png": 58
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work ^\.\/.*$
// module id = 129
// module chunks = 0